module.exports = __webpack_public_path__ + "static/media/auth-logo.5911f723.svg";